import { Detect } from "../internal/Detect"

/** `FileReaderSync` as `lib.webworker.d.ts` declares it.
 *
 * Spelled out rather than referenced because this project's `lib` is DOM-only,
 * so that declaration is not loaded — and adding `WebWorker` to reach it would
 * mean adding it to every tsconfig base a consumer might extend, since the
 * type has to resolve where the caller compiles rather than here. Kept whole
 * rather than trimmed to the one method used, so it stays the platform's
 * interface and not our corner of it. */
type FileReaderSync = {
  readAsArrayBuffer: (blob: Blob) => ArrayBuffer
  readAsBinaryString: (blob: Blob) => string
  readAsDataURL: (blob: Blob) => string
  readAsText: (blob: Blob, encoding?: string) => string
}

/** `FileReaderSync`, or `undefined` where the environment has none.
 *
 * Present in a worker and nowhere else, so asking for it is also how to find
 * out whether this is one. */
export const GetFileReaderSync = (): (new () => FileReaderSync) | undefined =>
  Detect("FileReaderSync")
